import CreditCardHeader from './credit-card-header';

export default CreditCardHeader;
